/** @format */
import React from 'react';
import TextField from '@mui/material/TextField';
import { Controller } from 'react-hook-form';
import { Autocomplete } from '@mui/material';
import { withStyles } from '@mui/styles';
import { useStyles } from './style';
import { InputAdornment, InputLabel } from '@mui/material';
import { api } from 'utility';
import { LoadingPage, LabelWithToolTip, Icons } from 'components';
import { LabelLine } from 'components/InputV2/components';
import { getServiceCallApi } from '../../../services/ServiceSetServices';
import useCustomHook from '../../../hooks';


const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(1),
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input': {
      padding: '1.5px 4px',
    },
    '& .MuiInputLabel-formControl': {
      top: '-7px',
      color: '#546e7a',
      fontSize: '12px',
    },
    '& .MuiInputAdornment-root': { color: '#546e7a' },
  },
}))(TextField);

const WebServiceAutoComplete = ({
  name,
  register,
  required,
  label,
  control,
  list,
  defaultValue = '',
  forceValue,
  onChangeValue,
  asterisk = true,
  preventAddCustomOption = false,
  labelTextField = '',
  setWebServices,
  tooltip,
  ...rest
}) => {
  const classes = useStyles();
  const { loading, setLoading } = useCustomHook();

  const id = `autocomplete-label-${name}`;

  const getList = (val) => {
    if (val.length > 2) {
      const index = list.findIndex((item) => {
        return item.label.search(val) > -1 || item.value.toString().search(val) > -1;
      });

      if (index > -1) {
        return;
      }

      const sendQuery = async () => {
        setLoading(true);

        try {
          const params = { offset: 0, size: 5 };

          if (isNaN(val)) {
            params.text = val;
          } else {
            params.id = val;
          }

          const result = await getServiceCallApi(params);

          const data = result.result;

          if (data.length > 0) {
            const list = data.map((item) => ({
              value: item.id,
              label: item.name,
            }));

            setWebServices((prev) => [...prev, ...list]);
          }
          setLoading(false);
        } catch (e) {
          if (!api.axiosLib.isCancel(e)) {
            setLoading(false);
          }
        }
      };

      sendQuery();
    }
  };

  return (
    <Controller
      name={name}
      render={({ field: { onChange, value } }) => (
        <Autocomplete
          {...rest}
          className={classes.root}
          value={forceValue ?? value}
          onChange={(event, newValue) => {
            onChangeValue(newValue);
          }}
          onInputChange={(event, newInputValue) => {
            if (newInputValue) {
              getList(newInputValue);
            }
          }}
          filterOptions={(options, params) => {
            const filtered = options.filter(
              (item) =>
                item.value.toString().search(params.inputValue) > -1 ||
                item.label.search(params.inputValue) > -1,
            );

            return filtered;
          }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          id={id}
          options={list}
          isOptionEqualToValue={(option, value) => {
            return option.value === value.value;
          }}
          getOptionLabel={(option) => {
            if (typeof option === 'string') {
              return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
              return option.inputValue;
            }
            // Regular option
            return option.label;
          }}
          renderOption={(optionProps, option) => (
            <li {...optionProps}>
              <span>{option.label}</span>&nbsp;-&nbsp;
              <small>شناسه سرویس: ({option.value})</small>
            </li>
          )}
          renderInput={(params) => (
            <>
              <InputLabel shrink htmlFor={params?.name} className={classes.label}>
                <LabelLine
                  label={<LabelWithToolTip label={label} description={tooltip} />}
                  required={required}
                />
              </InputLabel>
              <BootstrapInput
                {...params}
                placeholder={labelTextField}
                variant="outlined"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading && <LoadingPage />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icons icon='Search' color="#546e7a" size="18" />
                    </InputAdornment>
                  ),
                }}
              />
            </>
          )}
        />
      )}
      control={control}
      defaultValue={defaultValue}

    />
  );
};

export default WebServiceAutoComplete;
